(() => {
  if (window.__ctcFinalsLoaded) return;
  window.__ctcFinalsLoaded = true;
  const audienceKey = 'ctc-finals-audience';

  const normalizeVideoUrl = (url) => {
    if (!url) return '';
    try {
      const parsed = new URL(url, window.location.origin);
      if (parsed.hostname.includes('youtube.com') && parsed.searchParams.get('v')) {
        return `https://www.youtube-nocookie.com/embed/${parsed.searchParams.get('v')}?rel=0`;
      }
      if (parsed.hostname === 'youtu.be') {
        return `https://www.youtube-nocookie.com/embed/${parsed.pathname.replace('/', '')}?rel=0`;
      }
      if (parsed.hostname.includes('vimeo.com') && /^\/\d+/.test(parsed.pathname)) {
        return `https://player.vimeo.com/video/${parsed.pathname.split('/').filter(Boolean)[0]}`;
      }
      return parsed.href;
    } catch (_) {
      return url;
    }
  };

  const setAudience = (value) => {
    document.documentElement.dataset.ctcAudience = value;
    try { window.localStorage.setItem(audienceKey, value); } catch (_) {}

    document.querySelectorAll('[data-ctc-audience-button]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.ctcAudienceButton === value));
    });

    document.querySelectorAll('[data-ctc-audiences]').forEach((element) => {
      const audiences = element.dataset.ctcAudiences.split(',').map((item) => item.trim());
      element.dataset.ctcFiltered = String(!audiences.includes('all') && !audiences.includes(value));
    });
  };

  const initTabs = (root) => {
    root.querySelectorAll('[data-ctc-tabs]').forEach((tabset) => {
      if (tabset.dataset.ctcReady) return;
      tabset.dataset.ctcReady = 'true';
      const buttons = [...tabset.querySelectorAll('[data-ctc-tab-button]')];
      const panels = [...root.querySelectorAll(`[data-ctc-tab-panel][data-ctc-group="${tabset.dataset.ctcTabs}"]`)];
      const activate = (id, focus = false) => {
        buttons.forEach((button) => {
          const selected = button.dataset.ctcTabButton === id;
          button.setAttribute('aria-selected', String(selected));
          button.tabIndex = selected ? 0 : -1;
          if (selected && focus) button.focus();
        });
        panels.forEach((panel) => { panel.hidden = panel.dataset.ctcTabPanel !== id; });
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => activate(button.dataset.ctcTabButton));
        button.addEventListener('keydown', (event) => {
          if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;
          activate(buttons[next].dataset.ctcTabButton, true);
        });
      });
      const initial = buttons.find((button) => button.getAttribute('aria-selected') === 'true') || buttons[0];
      if (initial) activate(initial.dataset.ctcTabButton);
    });
  };

  const initDialogs = (root) => {
    root.querySelectorAll('[data-ctc-open]').forEach((trigger) => {
      if (trigger.dataset.ctcReady) return;
      trigger.dataset.ctcReady = 'true';
      trigger.addEventListener('click', () => {
        const dialog = document.getElementById(trigger.dataset.ctcOpen);
        if (!dialog) return;
        dialog.querySelectorAll('[data-ctc-video-src]').forEach((frame) => {
          if (!frame.src) frame.src = normalizeVideoUrl(frame.dataset.ctcVideoSrc);
        });
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      });
    });

    root.querySelectorAll('dialog.ctc-dialog').forEach((dialog) => {
      if (dialog.dataset.ctcReady) return;
      dialog.dataset.ctcReady = 'true';
      const close = () => {
        dialog.querySelectorAll('[data-ctc-video-src]').forEach((frame) => { frame.removeAttribute('src'); });
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
      };
      dialog.querySelectorAll('[data-ctc-close]').forEach((button) => button.addEventListener('click', close));
      dialog.addEventListener('click', (event) => { if (event.target === dialog) close(); });
      dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
    });
  };

  const initReveal = (root) => {
    const items = root.querySelectorAll('.ctc-reveal:not(.is-visible)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: .12 });
    items.forEach((item) => observer.observe(item));
  };

  const initRoot = (root) => {
    if (!root) return;
    root.querySelectorAll('[data-ctc-audience-button]').forEach((button) => {
      if (button.dataset.ctcReady) return;
      button.dataset.ctcReady = 'true';
      button.addEventListener('click', () => setAudience(button.dataset.ctcAudienceButton));
    });
    initTabs(root);
    initDialogs(root);
    initReveal(root);
    let selected = 'queen';
    try { selected = window.localStorage.getItem(audienceKey) || selected; } catch (_) {}
    setAudience(selected);
  };

  const initAll = () => document.querySelectorAll('[data-ctc-root]').forEach(initRoot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initRoot(event.target.querySelector('[data-ctc-root]')));
})();
